import { useEffect, useRef, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import Icofont from 'react-icofont';
import { useWindowScroll } from 'react-use';
import styled from 'styled-components';

import logo from 'assets/logo_color.png';

const NavbarContainer = styled(Navbar)`
    padding-top: 30px;
    padding-bottom: 30px;

    background-color: transparent;

    ${(props): string =>
        props.scrolled &&
        `
    padding-top: 15px;
    padding-bottom: 15px;
    background-color: rgb(0, 0, 0, 0.5);
  `}

    transition: all 0.3s;

    @media (max-width: ${(props): string => props.theme.lg}px) {
        padding-top: 15px;
        padding-bottom: 15px;
        background-color: rgb(0, 0, 0, 0.5);
    }

    .dropdown-toggle::before {
        display: none;
    }

    .dropdown-menu {
        right: 80%;
    }
`;

const NavLink = styled(Nav.Link)`
    color: white !important;

    opacity: 0.6;

    :hover {
        opacity: 1;
    }

    ${(props): string =>
        props.active ? `color: #fec826 !important; opacity: 1;` : ''}

    transition: all 0.3s;
`;

const NavbarToggle = styled(Navbar.Toggle)`
    border-color: white;
`;

const MenuIcon = styled(Icofont)`
    color: white;
`;

export default function Header(): JSX.Element {
    const { y } = useWindowScroll();
    const [active, setActive] = useState('home');
    const navbarRef = useRef<HTMLElement>(null);

    useEffect(() => {
        if (y === 0) {
            setActive('home');
            return;
        }

        const navbarHeight = navbarRef.current?.offsetHeight as number;

        const sections = ['contact', 'visit', 'catalogs', 'about'];

        for (const section of sections) {
            const topPos =
                (document?.getElementById(section)?.getBoundingClientRect?.()
                    ?.top as number) + window.scrollY;

            if (y - topPos + navbarHeight > 0) {
                setActive(section);
                break;
            }
        }
    }, [y]);

    return (
        <NavbarContainer
            expand="lg"
            fixed="top"
            scrolled={y > 0 ? 'true' : undefined}
            ref={navbarRef}
        >
            <Container>
                <Navbar.Brand href="#home">
                    <img src={logo} alt="logo" width={100} />
                </Navbar.Brand>
                <div className="d-flex flex-row align-items-baseline">
                    <NavbarToggle aria-controls="basic-navbar-nav">
                        <MenuIcon icon="navigation-menu" />
                    </NavbarToggle>

                    {/*<CartDropdownButton iconClassname="d-lg-none" />*/}
                </div>
                <Navbar.Collapse
                    id="basic-navbar-nav"
                    className="justify-content-end"
                >
                    <Nav>
                        <NavLink href="#home" active={active === 'home'}>
                            INICIO
                        </NavLink>
                        <NavLink href="#about" active={active === 'about'}>
                            ACERCA
                        </NavLink>
                        <NavLink
                            href="#catalogs"
                            active={active === 'catalogs'}
                        >
                            CATALOGOS
                        </NavLink>
                        <NavLink href="#visit" active={active === 'visit'}>
                            VISITANOS
                        </NavLink>
                        <NavLink href="#contact" active={active === 'contact'}>
                            CONTACTO
                        </NavLink>
                    </Nav>
                    {/*<CartDropdownButton iconClassname="d-none d-lg-block" />*/}
                </Navbar.Collapse>
            </Container>
        </NavbarContainer>
    );
}
